import React, { useEffect, useState } from 'react'
import AccountSidebar from '../../components/AccountSidebar';
import { toast } from 'react-hot-toast';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useBlogContext } from '../../../fetchdata/BlogContext';
import getDecryptData from '../../../helper/getDecryptData';
import axiosInstance from '../../../axiosInstance';

const AccountRequest = () => {
  const { Headers, isHeader } = useBlogContext();

 
    const [loading, setloading] = useState(true);
  
    const [Data, setData] = useState({});

    const decryptdatajson = getDecryptData();
    const userId = decryptdatajson?._id ?? '';


  const getData = async () => {
 

    setloading(true);
    try {
      const { data } = await axiosInstance.get(`/get-friend-requests/${userId}`);
      setData(data.requests ?? []);

      // Delay the execution of buildScript by 1 secon
    }
    catch (error) {
      console.log(error);
      // toast.error("Error fetching Single Blog!");
    } finally {
      setloading(false);
    }


  };


  useEffect(() => {
    getData();
    window.scrollTo(0, 0);
  }, []);


  const AcceptFriend = async (recId) => {


    const finalData = {
      senderId: userId,
      receiverId : recId
    }
    setloading(true);
    try {
      const  {data}   = await axiosInstance.post(`/accept-request`,finalData);
  
         console.log('datadata',data)

      const {success} = data;
      if(success){
      toast.success('Accept connection successfully');

       } 
      // Delay the execution of buildScript by 1 secon
    }
    catch (error) {
      console.log(error);
    toast.error(error.response.data.message ?? 'Getting error');
    } finally {
       setloading(false);
      getData();
    }
 
  };
 
  
     const cancelFriend = async (recId) => {
  
  
      const finalData = {
        senderId: userId,
        receiverId : recId
      }
      setloading(true);
      try {
        const  {data}   = await axiosInstance.post(`/reject-request`,finalData);
    
   
        const {success} = data;
       console.log('datadata',data)
  
        if(success){
        toast.success('Cancel connection successfully');
  
         } 
        // Delay the execution of buildScript by 1 secon
      }
      catch (error) {
        console.log(error);
      toast.error(error.response.data.message ?? 'Getting error');
      } finally {
         setloading(false);
        getData();
      }
   
    };
  

  return (
    <>
      <Header />

      <Helmet>
        <title> Account connection Request | {window.location.hostname}</title>

      </Helmet>

      <div className="user-dasboard whitesmoke" >

        <div className="container pt-4">
          <div className="row pb-4">

            <AccountSidebar />

            <div className="col-lg-9 my-lg-0 my-1">
              <div id="main-content" className="bg-white border">
                <h4 className="mb-2"> All Request</h4>
                <div className=" mt-4">

     <div className="row gy-3">

        {!loading ? 
       
  Data.length !== 0 ?
  Data.map((user, index) => (

        <div className="col-md-3 col-12" key={index}>
          <div className="card border rounded-4 overflow-hidden">
            <div className="card-body p-2">
              <div className="row gap-3">
                <div className="col-12">
                  <Link
                    to={`/profile/${user._id}`} >
                    <img
                   onError={(e) => e.target.src = '/assets/img/profile-pic.jpg'} // Fallback to default image on error
                       src={user.profile}
                      className="w-100 rounded"
                      style={{ aspectRatio: "1 / 1", objectFit: "cover" }}
                    />
                  </Link>
                </div>
                <div className="flex-grow-1">
                  <h4 className="h4 fw-medium mt-1 mb-1">
                    <Link
                      className="text-decoration-none"
                       to={`/profile/${user._id}`}
                    >
                      {" "}
                     {user.username ?? 'anonymous'}
                    </Link>
                  </h4>
                  <div className="text-muted small mb-1">
                    <i className="ri-map-pin-line" />  {user.statename ? user.statename + ' India' : 'India'}
                  </div>
                   <div className="d-flex gap-2 mt-1 pt-0 align-items-center">
                    {/* <Link
                      className="btn btn-outline-primary btn-sm"
                      to={`/profile/${user._id}`}
                    >
                      View Details
                    </Link> */}

               { user.friendRequests && user.friendRequests.includes(userId) ? 
  <button
                          type="button"
                          className='btn btn-danger btn-sm'
                          onClick={()=>{cancelFriend(user._id)}}
                        >
                          <i className="ri-close-fill" /> Cancel Connection
                        </button> : 
                             <button
                      type="button"
                      className='btn btn-success btn-sm'
                      onClick={()=>{AcceptFriend(user._id)}}
                    >
                      <i className="ri-add-fill" /> Accept Connection
                    </button>
}
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  )) : <div style={{minHeight:'50vh'}} className='d-flex justify-content-center align-items-center '>
    <div className='text-center'>
       <i class="ri-alert-fill text-primary h1"/>
 <p className='h4'> No Request Found  </p>
  
  </div> 
  </div> : 
   Array.from({ length: 4 }).map((_, index) => (
        <div className="col-md-3 col-12 rounded" key={index}>
          <div className="skeleton w-100" style={{ aspectRatio: '4/4', height: 'auto' }}></div>
       <div className="skeleton  mt-2" style={{   height: '25px', width:'40%' }}></div>
        <div className="skeleton  mt-2" style={{   height: '25px', width:'30%' }}></div>
<div className="d-flex mt-2 gap-3">
         <div className="skeleton w-100 rounded-pill" style={{   height: '35px'  }}></div>

       <div className="skeleton  w-100 rounded-pill" style={{   height: '35px'  }}></div>

  </div>
        </div>
      )) 
       }
      </div>
                  
                </div>
              </div>
            </div>



          </div>
        </div>

      </div >


      <Footer />
    </>
  )
}

export default AccountRequest